import { Heading, MarkdownRenderer } from "@/ui";
import { sections } from "./content";

export const ResearchSections = () => {
  return (
    <div className="flex flex-col gap-6 sm:gap-9">
      {sections.map((section, index) => {
        return (
          <div className="flex flex-col gap-2" key={index}>
            <Heading className="text-content" level={3}>
              {section.title}
            </Heading>

            <MarkdownRenderer>{section.content}</MarkdownRenderer>
          </div>
        );
      })}
    </div>
  );
};
